
import { createWebHistory, createRouter } from "vue-router";


/////路由
const routes = [
  {
    path: "/",
    name: "404",
    component: ()=> import("../view/404.vue")
  }, {
    path: "/404",
    name: "404",
    component: ()=> import("../view/404.vue")
  }, 
  {
    path: "/WxPay/Login/:OrgId",
    name: "Login",
    component: ()=> import("../view/Login.vue")
  }, 
  {
    path: "/WxPay/Oauth2",
    name: "oauth2",
    component: ()=> import("../view/oauth2.vue")
  }, 
 
  {
    path: "/WxPay/Index",
    name: "Index",
    component: ()=> import("../view/Index.vue"),
    children: [

        {
          path: "/WxPay/Home",
          name: "Home",
          component: ()=> import("../view/Home/Index.vue")
        },
        {
          path: "/WxPay/Pay",
          name: "Pay",
          component: ()=> import("../view/Pay/Index.vue")
        },
        {
          path: "/WxPay/My",
          name: "My",
          component: ()=> import("../view/My/Index.vue")
        },
        {
          path: "/WxPay/My/Recharge",
          name: "MyRecharge",
          component: ()=> import("../view/My/Recharge.vue")
        },{
          path: "/WxPay/My/Password",
          name: "MyPassword",
          component: ()=> import("../view/My/Password.vue")
        },


    ]
  }, 




];
const router = createRouter({
  history: createWebHistory(),
  routes,
});


// 为路由对象添加路由导航守卫
router.beforeEach((to, from, next) => {

  if (to.path === "/") {
    next({ path: '/404', replace: true })
  }
  else  if(to.path === "/404")
  {
    next()
  }
  else if (to.path.indexOf('/WxPay/Login') > -1)
  {  
    ///如果没有传orgId，报错
      if(to.path === "/WxPay/Login")
      {
        next({ path: '/404', replace: true })
      }
      else
      {
          //  如果用户访问的是登录页面 直接放行
          next()
      }
    
  }
  else
  {

    let token = window.sessionStorage.getItem('AcceptToken');  //  从LocalStorage中得到token
    // const timeOver = window.sessionStorage.getItem('Expires');  //   获取存储token的结束时间
  
    // 如果没有token值 那么就跳转到'/login
    if (!token) {
          //message: '登录状态过期，请重新登录',
          next('/WxPay/Login/'+sessionStorage.getItem("OrgId"));
    }
    else
    {
        // 如果有token则放行
        next();
    }
  }


})






// // 为路由对象添加路由导航守卫
// router.beforeEach((to, from, next) => {
//   if (to.path === '/Login') {  //  如果用户访问的是登录页面 直接放行
//     return next();
//   }

  

//   let token = window.localStorage.getItem('AcceptToken');  //  从LocalStorage中得到token
//   const timeOver = window.localStorage.getItem('Expires');  //   获取存储token的结束时间


//   let date = new Date().getTime();  //  当前时间
//   if(date > timeOver) {  //  如果大于说明是token过期了
//     token = null;
//     window.localStorage.removeItem("AcceptToken");
//     window.localStorage.removeItem("tokenStartTime");
//   }
//   else  /////token没有过期
//   {
//     if((timeOver-date)<1000*60*10) ////如果token过期时间小于10分钟
//     {
//         ////重新读取token
//       RefreshToken()
//     }
      
      

//   }

//   // 如果没有token值 那么就跳转到'/login
//   if (!token) {
//     if(to.path == '/Login') {
//       return next();
//     }
//     //message: '登录状态过期，请重新登录',
//     return next('/Login');
//   }
//   else
//   {
//       // 如果有token则放行
//       next();
//   }
// })

export default router;


